import { useFormikContext } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';
import SettingsOption, { OptionType } from '../SettingsOption';

enum MomentPermission {
  Admin = 'admin',
  Member = 'member'
}

const MomentSettings = () => {
  const { t } = useTranslation(['events']);
  const { values, setFieldValue } = useFormikContext<any>();

  const momentsPermissions = values?.momentsPermissions ?? {
    createMoments: 'member',
    commentMoments: 'member'
  };

  const toggleUploadPermission = () => {
    if (momentsPermissions.createMoments === MomentPermission.Admin) {
      setFieldValue('momentsPermissions', {
        ...momentsPermissions,
        createMoments: MomentPermission.Member
      });
    } else {
      setFieldValue('momentsPermissions', {
        ...momentsPermissions,
        createMoments: MomentPermission.Admin
      });
    }
  };

  const toggleCommentsPermission = () => {
    if (momentsPermissions.commentMoments === MomentPermission.Admin) {
      setFieldValue('momentsPermissions', {
        ...momentsPermissions,
        commentMoments: MomentPermission.Member
      });
    } else {
      setFieldValue('momentsPermissions', {
        ...momentsPermissions,
        commentMoments: MomentPermission.Admin
      });
    }
  };

  return (
    <div className="mt-6">
      <h3 className="text-lg font-semibold">{t('events:settings.moments')}</h3>
      <SettingsOption
        icon={<img src="/img/events/create/moments.svg" className="w-6 h-6" />}
        title={t('events:settings.momentPermissions.onlyAdminsUpload')}
        type={OptionType.Toggle}
        isActive={
          values?.momentsPermissions?.createMoments === MomentPermission.Admin
        }
        onClick={toggleUploadPermission}
      />
      <SettingsOption
        icon={<img src="/img/events/create/moments.svg" className="w-6 h-6" />}
        title={t('events:settings.momentPermissions.onlyAdminsComment')}
        type={OptionType.Toggle}
        isActive={
          values?.momentsPermissions?.commentMoments === MomentPermission.Admin
        }
        onClick={toggleCommentsPermission}
      />
    </div>
  );
};

export default MomentSettings;
